import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight, Camera } from "@phosphor-icons/react";
import { StarDisplay } from "@/components/reviews/StarRating";
import useReviewViewer from "@/components/reviews/useReviewViewer";

export default function ReviewPhotoWall() {
  const [reviews, setReviews] = useState([]);
  const { photos, openPhoto, viewer } = useReviewViewer(reviews);

  useEffect(() => {
    api.get("/reviews/photos", { params: { limit: 12 } }).then((r) => setReviews(r.data || [])).catch(() => setReviews([]));
  }, []);

  if (!photos.length) return null;
  return (
    <section data-testid="review-photo-wall" className="py-16 bg-[#1C211E] text-white overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-white/50 flex items-center gap-2"><Camera size={14} /> From the crew</div>
          <h2 className="font-display text-3xl md:text-4xl mt-2">Real catches. Real customers.</h2>
        </div>
        <Link to="/reviews" data-testid="photo-wall-all-reviews" className="text-sm inline-flex items-center gap-2 text-[#E8A37F] hover:text-white transition-colors">
          Read all reviews <ArrowRight size={14} />
        </Link>
      </div>
      <div className="flex gap-4 overflow-x-auto px-6 pb-2 snap-x [scrollbar-width:thin] max-w-7xl mx-auto">
        {photos.slice(0, 16).map((t, i) => (
          <button key={t.key} type="button" data-testid={`photo-wall-tile-${i}`} onClick={() => openPhoto(t.path)}
            className="group relative flex-shrink-0 w-56 h-56 md:w-64 md:h-64 rounded-sm overflow-hidden snap-start cursor-zoom-in">
            <img src={t.src} alt={t.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
            <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity text-left">
              <StarDisplay value={t.review.rating} size={12} dark />
              <div className="text-xs mt-1 truncate">{t.review.name}</div>
            </div>
          </button>
        ))}
      </div>
      {viewer}
    </section>
  );
}
